import { FunctionComponent } from "react";

import {
  ApplicationsSelect,
  ApplicationsSelectProps
} from "../../pickers/ApplicationsSelect";
import { useFieldContext, useFieldRegister } from "@bps/fluent-ui";

type FormApplicationsSelectProps = Omit<
  ApplicationsSelectProps,
  "selectedKeys" | "onChangeSelectedKeys"
> & { name: string };

export const FormApplicationsSelect: FunctionComponent<FormApplicationsSelectProps> = ({
  name,
  ...restUsersSelectProps
}) => {
  useFieldRegister(name);
  const { value, setFieldValue } = useFieldContext<string>(name);

  return (
    <ApplicationsSelect
      selectedKeys={value}
      onChangeSelectedKeys={setFieldValue}
      {...restUsersSelectProps}
    />
  );
};
